import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import {
  CommonResponses,
  ElementType,
  NumberFormat,
  SelectCombos,
} from '../Enums/constants';
import SurveyConditionalSegment from '../components/SurveyConditionalSegment';


export const PabsVocTab = () => {
  return (
    <SurveyPage>
      <SurveyTitleArea labelText='' />
      <SurveyContentContainer>
        <SurveySection labelText='Voice of the Customer (VoC)'>
          <p>
            The VoC Framework standardizes how pension plans ask for feedback
            from members and employers, so that comparisons can be made across plans.

            If you have a member satisfaction surveying program and would like
            comparisons with others then please supply the data on this page.
          </p>
          <p>
            Supplying VoC data is optional.
            If you supply data, you will receive a report comparing your results to other participants.
          </p>
          <p>
            We recognize that you may not be able to supply data because you don't
            survey members or because you have a fundamentally different approach
            or questions to those suggested here.
            If this is the case then this tab can be ignored
            (and you can proceed to 'submit' the data if you have completed the rest of the survey).

          </p>
          <p>
            We divide participants into two groups:
            <ul>
              <li><strong>Optimized</strong>: Plans that are applying the VoC Framework fully and where comparisons are valid, and</li>
              <li><strong>Directional</strong>: Plans that ask similar questions but where differences in the questions, scales or approach might impact the validity of comparisons.</li>  
            </ul>
          </p>
          <p>
            The report will distinguish between optimized and directional scores.
          </p>
        </SurveySection>
        <SurveySection labelText='Telephone calls'>
          <SurveyElement
            questionNumber='95'
            labelText="Did you do 'single activity' surveying, only targeted to members that called you on the telephone?"
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='CallsSurveyYN'
          />
          <SurveyConditionalSegment
            showIf={{
              CallsSurveyYN: { not: CommonResponses.NO.toLowerCase() }
            }}
          >
            <SurveyElement
              labelText="Optimized question: How satisfied were you with the service you received on the telephone [today/when you called]?"
            />
            <SurveyElement
              questionNumber='95.a'
              labelText="Did you use the optimized question above verbatim?"
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              name='CallsYN'
              subQuestion
            />
            <SurveyElement
              questionNumber='95.a.a1'
              labelText="If you didn't use the optimized question, what was the closest matching question in your survey?"
              inputType={ElementType.TEXTAREA}
              name='CallsDirectionalQuestionUse'
              doubleSubQuestion
              showIf={{
                CallsYN: { not: CommonResponses.YES.toLowerCase() }
              }}
            />
            <SurveyElement
              questionNumber='95.b'
              labelText="How many points are on your scale?"
              inputType={ElementType.SELECT}
              options={SelectCombos.ONE_TO_TEN}
              placeholder='#, n/a'
              name='CallsScale'
              note="If you have a 1 - 7 scale, then add data in columns 1 - 7 and so on.  If there were zero responses against a point on your scale then input '0' - don't leave the field blank."
              allowNA
              subQuestion
            />
            <SurveyElement
              labelText="# of response with score of 1"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='CallsScore1'
              allowNA
              doubleSubQuestion
              showIf={{
                CallsScale: { gte: 1 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 2"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='CallsScore2'
              allowNA
              doubleSubQuestion
              showIf={{
                CallsScale: { gte: 2 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 3"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='CallsScore3'
              allowNA
              doubleSubQuestion
              showIf={{
                CallsScale: { gte: 3 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 4"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='CallsScore4'
              allowNA
              doubleSubQuestion
              showIf={{
                CallsScale: { gte: 4 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 5"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='CallsScore5'
              allowNA
              doubleSubQuestion
              showIf={{
                CallsScale: { gte: 5 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 6"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='CallsScore6'
              allowNA
              doubleSubQuestion
              showIf={{
                CallsScale: { gte: 6 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 7"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='CallsScore7'
              allowNA
              doubleSubQuestion
              showIf={{
                CallsScale: { gte: 7 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 8"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='CallsScore8'
              allowNA
              doubleSubQuestion
              showIf={{
                CallsScale: { gte: 8 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 9"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='CallsScore9'
              allowNA
              doubleSubQuestion
              showIf={{
                CallsScale: { gte: 9 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 10"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='CallsScore10'
              allowNA
              doubleSubQuestion
              showIf={{
                CallsScale: { gte: 10 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='CallsScore1'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                CallsScale: { eq: 1 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='CallsScore1 + CallsScore2'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                CallsScale: { eq: 2 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='CallsScore1 + CallsScore2 + CallsScore3'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                CallsScale: { eq: 3 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='CallsScore1 + CallsScore2 + CallsScore3 + CallsScore4'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                CallsScale: { eq: 4 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='CallsScore1 + CallsScore2 + CallsScore3 + CallsScore4 + CallsScore5'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                CallsScale: { eq: 5 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='CallsScore1 + CallsScore2 + CallsScore3 + CallsScore4 + CallsScore5 + CallsScore6'
              format={NumberFormat.DECIMAL1}
              doubleSubQuestion
              showIf={{
                CallsScale: { eq: 6 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='CallsScore1 + CallsScore2 + CallsScore3 + CallsScore4 + CallsScore5 + CallsScore6 + CallsScore7'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                CallsScale: { eq: 7 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='CallsScore1 + CallsScore2 + CallsScore3 + CallsScore4 + CallsScore5 + CallsScore6 + CallsScore7 + CallsScore8'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                CallsScale: { eq: 8 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='CallsScore1 + CallsScore2 + CallsScore3 + CallsScore4 + CallsScore5 + CallsScore6 + CallsScore7 + CallsScore8 + CallsScore9'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                CallsScale: { eq: 9 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='CallsScore1 + CallsScore2 + CallsScore3 + CallsScore4 + CallsScore5 + CallsScore6 + CallsScore7 + CallsScore8 + CallsScore9 + CallsScore10'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                CallsScale: { eq: 10 }
              }}
            />
            <SurveyElement
              questionNumber='95.c'
              labelText="Number of members surveyed"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='CallsSurveyed'
              note="Please provide either the number of surveys sent/popped-up/requested OR provide the response rate"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='95.d'
              labelText="% response rate"
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE_UK}
              placeholder='%, n/a'
              name='CallsResponseRate'
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='95.e'
              labelText="What were your scale labels? (Contextual Data)"
              inputType={ElementType.TEXT}
              name='CallsScaleLabels'
              note="e.g., 1-10 (with 1 being not at all satisfied and 10 being extremely satisfied)"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='95.f'
              labelText="How quickly do you typically send your survey after the activity?"
              note="e.g., Within one month after the quarter closes."
              name='CallsTimeliness'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='95.g'
              labelText="How frequently are you surveying?"
              note="e.g., every quarter or ongoing / constant"
              name='CallsFrequency'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='95.h'
              labelText="Method"
              note="e.g., SurveyMonkey - online survey"
              name='CallsSurveyMethod'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection labelText='Secure website'>
          <SurveyElement
            questionNumber='96'
            labelText="Did you do 'single activity' surveying, only targeted to members that used the website?"
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='SecureWebSurveyYN'
          />
          <SurveyConditionalSegment
            showIf={{
              SecureWebSurveyYN: { not: CommonResponses.NO.toLowerCase() }
            }}
          >
            <SurveyElement
              labelText="Optimized question: How easy was it for you to use our secure website?"
            />
            <SurveyElement
              questionNumber='96.a'
              labelText="Did you use the optimized question above verbatim?"
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              name='SecureWebYN'
              subQuestion
            />
            <SurveyElement
              questionNumber='96.a.a1'
              labelText="If you didn't use the optimized question, what was the closest matching question in your survey?"
              inputType={ElementType.TEXTAREA}
              name='SecureWebDirectionalQuestionUse'
              doubleSubQuestion
              showIf={{
                SecureWebYN: { not: CommonResponses.YES.toLowerCase() }
              }}
            />
            <SurveyElement
              questionNumber='96.b'
              labelText="How many points are on your scale?"
              inputType={ElementType.SELECT}
              options={SelectCombos.ONE_TO_TEN}
              placeholder='#, n/a'
              name='SecureWebScale'
              note="If you have a 1 - 7 scale, then add data in columns 1 - 7 and so on.  If there were zero responses against a point on your scale then input '0' - don't leave the field blank."
              allowNA
              subQuestion
            />
            <SurveyElement
              labelText="# of response with score of 1"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='SecureWebScore1'
              allowNA
              doubleSubQuestion
              showIf={{
                SecureWebScale: { gte: 1 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 2"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='SecureWebScore2'
              allowNA
              doubleSubQuestion
              showIf={{
                SecureWebScale: { gte: 2 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 3"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='SecureWebScore3'
              allowNA
              doubleSubQuestion
              showIf={{
                SecureWebScale: { gte: 3 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 4"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='SecureWebScore4'
              allowNA
              doubleSubQuestion
              showIf={{
                SecureWebScale: { gte: 4 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 5"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='SecureWebScore5'
              allowNA
              doubleSubQuestion
              showIf={{
                SecureWebScale: { gte: 5 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 6"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='SecureWebScore6'
              allowNA
              doubleSubQuestion
              showIf={{
                SecureWebScale: { gte: 6 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 7"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='SecureWebScore7'
              allowNA
              doubleSubQuestion
              showIf={{
                SecureWebScale: { gte: 7 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 8"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='SecureWebScore8'
              allowNA
              doubleSubQuestion
              showIf={{
                SecureWebScale: { gte: 8 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 9"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='SecureWebScore9'
              allowNA
              doubleSubQuestion
              showIf={{
                SecureWebScale: { gte: 9 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 10"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='SecureWebScore10'
              allowNA
              doubleSubQuestion
              showIf={{
                SecureWebScale: { gte: 10 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='SecureWebScore1'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                SecureWebScale: { eq: 1 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='SecureWebScore1 + SecureWebScore2'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                SecureWebScale: { eq: 2 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='SecureWebScore1 + SecureWebScore2 + SecureWebScore3'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                SecureWebScale: { eq: 3 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='SecureWebScore1 + SecureWebScore2 + SecureWebScore3 + SecureWebScore4'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                SecureWebScale: { eq: 4 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='SecureWebScore1 + SecureWebScore2 + SecureWebScore3 + SecureWebScore4 + SecureWebScore5'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                SecureWebScale: { eq: 5 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='SecureWebScore1 + SecureWebScore2 + SecureWebScore3 + SecureWebScore4 + SecureWebScore5 + SecureWebScore6'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                SecureWebScale: { eq: 6 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='SecureWebScore1 + SecureWebScore2 + SecureWebScore3 + SecureWebScore4 + SecureWebScore5 + SecureWebScore6 + SecureWebScore7'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                SecureWebScale: { eq: 7 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='SecureWebScore1 + SecureWebScore2 + SecureWebScore3 + SecureWebScore4 + SecureWebScore5 + SecureWebScore6 + SecureWebScore7 + SecureWebScore8'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                SecureWebScale: { eq: 8 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='SecureWebScore1 + SecureWebScore2 + SecureWebScore3 + SecureWebScore4 + SecureWebScore5 + SecureWebScore6 + SecureWebScore7 + SecureWebScore8 + SecureWebScore9'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                SecureWebScale: { eq: 9 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='SecureWebScore1 + SecureWebScore2 + SecureWebScore3 + SecureWebScore4 + SecureWebScore5 + SecureWebScore6 + SecureWebScore7 + SecureWebScore8 + SecureWebScore9 + SecureWebScore10'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                SecureWebScale: { eq: 10 }
              }}
            />
            <SurveyElement
              questionNumber='96.c'
              labelText="Number of members surveyed"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='SecureWebSurveyed'
              note="Please provide either the number of surveys sent/popped-up/requested OR provide the response rate"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='96.d'
              labelText="% response rate"
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE_UK}
              placeholder='%, n/a'
              name='SecureWebResponseRate'
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='96.e'
              labelText="What were your scale labels? (Contextual Data)"
              inputType={ElementType.TEXT}
              name='SecureWebScaleLabels'
              note="e.g., 1-10 (with 1 being not at all satisfied and 10 being extremely satisfied)"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='96.f'
              labelText="How quickly do you typically send your survey after the activity?"
              note="e.g., Within one month after the quarter closes."
              name='SecureWebTimeliness'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='96.g'
              labelText="How frequently are you surveying?"
              note="e.g., every quarter or ongoing / constant"
              name='SecureWebFrequency'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='96.h'
              labelText="Method"
              note="e.g., SurveyMonkey - online survey"
              name='SecureWebSurveyMethod'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection labelText='Retirement from active'>
          <SurveyElement
            questionNumber='97'
            labelText="Did you do 'single activity' surveying, only targeted to members that retired from active?"
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='RetireActiveSurveyYN'
          />
          <SurveyConditionalSegment
            showIf={{
              RetireActiveSurveyYN: { not: CommonResponses.NO.toLowerCase() }
            }}
          >
            <SurveyElement
              labelText="Optimized question: Thinking about your retirement, how satisfied were you with the overall service you received from the administrator?"
            />
            <SurveyElement
              questionNumber='97.a'
              labelText="Did you use the optimized question above verbatim?"
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              name='RetireActiveYN'
              subQuestion
            />
            <SurveyElement
              questionNumber='97.a.a1'
              labelText="If you didn't use the optimized question, what was the closest matching question in your survey?"
              inputType={ElementType.TEXTAREA}
              name='RetireActiveDirectionalQuestionUse'
              doubleSubQuestion
              showIf={{
                RetireActiveYN: { not: CommonResponses.YES.toLowerCase() }
              }}
            />
            <SurveyElement
              questionNumber='97.b'
              labelText="How many points are on your scale?"
              inputType={ElementType.SELECT}
              options={SelectCombos.ONE_TO_TEN}
              placeholder='#, n/a'
              name='RetireActiveScale'
              note="If you have a 1 - 7 scale, then add data in columns 1 - 7 and so on.  If there were zero responses against a point on your scale then input '0' - don't leave the field blank."
              allowNA
              subQuestion
            />
            <SurveyElement
              labelText="# of response with score of 1"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireActiveScore1'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { gte: 1 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 2"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireActiveScore2'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { gte: 2 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 3"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireActiveScore3'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { gte: 3 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 4"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireActiveScore4'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { gte: 4 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 5"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireActiveScore5'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { gte: 5 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 6"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireActiveScore6'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { gte: 6 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 7"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireActiveScore7'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { gte: 7 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 8"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireActiveScore8'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { gte: 8 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 9"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireActiveScore9'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { gte: 9 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 10"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireActiveScore10'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { gte: 10 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireActiveScore1'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { eq: 1 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireActiveScore1 + RetireActiveScore2'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { eq: 2 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireActiveScore1 + RetireActiveScore2 + RetireActiveScore3'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { eq: 3 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireActiveScore1 + RetireActiveScore2 + RetireActiveScore3 + RetireActiveScore4'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { eq: 4 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireActiveScore1 + RetireActiveScore2 + RetireActiveScore3 + RetireActiveScore4 + RetireActiveScore5'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { eq: 5 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireActiveScore1 + RetireActiveScore2 + RetireActiveScore3 + RetireActiveScore4 + RetireActiveScore5 + RetireActiveScore6'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { eq: 6 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireActiveScore1 + RetireActiveScore2 + RetireActiveScore3 + RetireActiveScore4 + RetireActiveScore5 + RetireActiveScore6 + RetireActiveScore7'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { eq: 7 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireActiveScore1 + RetireActiveScore2 + RetireActiveScore3 + RetireActiveScore4 + RetireActiveScore5 + RetireActiveScore6 + RetireActiveScore7 + RetireActiveScore8'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { eq: 8 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireActiveScore1 + RetireActiveScore2 + RetireActiveScore3 + RetireActiveScore4 + RetireActiveScore5 + RetireActiveScore6 + RetireActiveScore7 + RetireActiveScore8 + RetireActiveScore9'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { eq: 9 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireActiveScore1 + RetireActiveScore2 + RetireActiveScore3 + RetireActiveScore4 + RetireActiveScore5 + RetireActiveScore6 + RetireActiveScore7 + RetireActiveScore8 + RetireActiveScore9 + RetireActiveScore10'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireActiveScale: { eq: 10 }
              }}
            />
            <SurveyElement
              questionNumber='97.c'
              labelText="Number of members surveyed"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireActiveSurveyed'
              note="Please provide either the number of surveys sent/popped-up/requested OR provide the response rate"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='97.d'
              labelText="% response rate"
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE_UK}
              placeholder='%, n/a'
              name='RetireActiveResponseRate'
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='97.e'
              labelText="What were your scale labels? (Contextual Data)"
              inputType={ElementType.TEXT}
              name='RetireActiveScaleLabels'
              note="e.g., 1-10 (with 1 being not at all satisfied and 10 being extremely satisfied)"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='97.f'
              labelText="How quickly do you typically send your survey after the activity?"
              note="e.g., Within one month after the quarter closes."
              name='RetireActiveTimeliness'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='97.g'
              labelText="How frequently are you surveying?"
              note="e.g., every quarter or ongoing / constant"
              name='RetireActiveFrequency'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='97.h'
              labelText="Method"
              note="e.g., SurveyMonkey - online survey"
              name='RetireActiveSurveyMethod'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection labelText='Retirement from inactive'>
          <SurveyElement
            questionNumber='98'
            labelText="Did you do 'single activity' surveying, only targeted to members that retired from deferred?"
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='RetireDeferredSurveyYN'
          />
          <SurveyConditionalSegment
            showIf={{
              RetireDeferredSurveyYN: { not: CommonResponses.NO.toLowerCase() }
            }}
          >
            <SurveyElement
              labelText="Optimized question: Thinking about your retirement, how satisfied were you with the overall service you received from the administrator?"
            />
            <SurveyElement
              questionNumber='98.a'
              labelText="Did you use the optimized question above verbatim?"
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              name='RetireDeferredYN'
              subQuestion
            />
            <SurveyElement
              questionNumber='98.a.a1'
              labelText="If you didn't use the optimized question, what was the closest matching question in your survey?"
              inputType={ElementType.TEXTAREA}
              name='RetireDeferredDirectionalQuestionUse'
              doubleSubQuestion
              showIf={{
                RetireDeferredYN: { not: CommonResponses.YES.toLowerCase() }
              }}
            />
            <SurveyElement
              questionNumber='98.b'
              labelText="How many points are on your scale?"
              inputType={ElementType.SELECT}
              options={SelectCombos.ONE_TO_TEN}
              placeholder='#, n/a'
              name='RetireDeferredScale'
              note="If you have a 1 - 7 scale, then add data in columns 1 - 7 and so on.  If there were zero responses against a point on your scale then input '0' - don't leave the field blank."
              allowNA
              subQuestion
            />
            <SurveyElement
              labelText="# of response with score of 1"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireDeferredScore1'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { gte: 1 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 2"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireDeferredScore2'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { gte: 2 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 3"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireDeferredScore3'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { gte: 3 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 4"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireDeferredScore4'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { gte: 4 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 5"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireDeferredScore5'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { gte: 5 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 6"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireDeferredScore6'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { gte: 6 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 7"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireDeferredScore7'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { gte: 7 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 8"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireDeferredScore8'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { gte: 8 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 9"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireDeferredScore9'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { gte: 9 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 10"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireDeferredScore10'
              allowNA
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { gte: 10 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireDeferredScore1'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { eq: 1 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireDeferredScore1 + RetireDeferredScore2'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { eq: 2 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireDeferredScore1 + RetireDeferredScore2 + RetireDeferredScore3'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { eq: 3 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireDeferredScore1 + RetireDeferredScore2 + RetireDeferredScore3 + RetireDeferredScore4'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { eq: 4 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireDeferredScore1 + RetireDeferredScore2 + RetireDeferredScore3 + RetireDeferredScore4 + RetireDeferredScore5'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { eq: 5 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireDeferredScore1 + RetireDeferredScore2 + RetireDeferredScore3 + RetireDeferredScore4 + RetireDeferredScore5 + RetireDeferredScore6'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { eq: 6 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireDeferredScore1 + RetireDeferredScore2 + RetireDeferredScore3 + RetireDeferredScore4 + RetireDeferredScore5 + RetireDeferredScore6 + RetireDeferredScore7'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { eq: 7 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireDeferredScore1 + RetireDeferredScore2 + RetireDeferredScore3 + RetireDeferredScore4 + RetireDeferredScore5 + RetireDeferredScore6 + RetireDeferredScore7 + RetireDeferredScore8'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { eq: 8 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireDeferredScore1 + RetireDeferredScore2 + RetireDeferredScore3 + RetireDeferredScore4 + RetireDeferredScore5 + RetireDeferredScore6 + RetireDeferredScore7 + RetireDeferredScore8 + RetireDeferredScore9'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { eq: 9 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='RetireDeferredScore1 + RetireDeferredScore2 + RetireDeferredScore3 + RetireDeferredScore4 + RetireDeferredScore5 + RetireDeferredScore6 + RetireDeferredScore7 + RetireDeferredScore8 + RetireDeferredScore9 + RetireDeferredScore10'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                RetireDeferredScale: { eq: 10 }
              }}
            />
            <SurveyElement
              questionNumber='98.c'
              labelText="Number of members surveyed"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='RetireDeferredSurveyed'
              note="Please provide either the number of surveys sent/popped-up/requested OR provide the response rate"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='98.d'
              labelText="% response rate"
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE_UK}
              placeholder='%, n/a'
              name='RetireDeferredResponseRate'
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='98.e'
              labelText="What were your scale labels? (Contextual Data)"
              inputType={ElementType.TEXT}
              name='RetireDeferredScaleLabels'
              note="e.g., 1-10 (with 1 being not at all satisfied and 10 being extremely satisfied)"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='98.f'
              labelText="How quickly do you typically send your survey after the activity?"
              note="e.g., Within one month after the quarter closes."
              name='RetireDeferredTimeliness'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='98.g'
              labelText="How frequently are you surveying?"
              note="e.g., every quarter or ongoing / constant"
              name='RetireDeferredFrequency'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='98.h'
              labelText="Method"
              note="e.g., SurveyMonkey - online survey"
              name='RetireDeferredSurveyMethod'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection labelText='New members'>
          <SurveyElement
            questionNumber='99'
            labelText="Did you do 'single activity' surveying, only targeted to new members?"
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='NewMemberSurveyYN'
          />
          <SurveyConditionalSegment
            showIf={{
              NewMemberSurveyYN: { not: CommonResponses.NO.toLowerCase() }
            }}
          >
            <SurveyElement
              labelText="Optimised question: How satisfied are you with the information provided to you on joining the administrator?"
            />
            <SurveyElement
              questionNumber='99.a'
              labelText="Did you use the optimized question above verbatim?"
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              name='NewMemberYN'
              subQuestion
            />
            <SurveyElement
              questionNumber='99.a.a1'
              labelText="If you didn't use the optimized question, what was the closest matching question in your survey?"
              inputType={ElementType.TEXTAREA}
              name='NewMemberDirectionalQuestionUse'
              doubleSubQuestion
              showIf={{
                NewMemberYN: { not: CommonResponses.YES.toLowerCase() }
              }}
            />
            <SurveyElement
              questionNumber='99.b'
              labelText="How many points are on your scale?"
              inputType={ElementType.SELECT}
              options={SelectCombos.ONE_TO_TEN}
              placeholder='#, n/a'
              name='NewMemberScale'
              note="If you have a 1 - 7 scale, then add data in columns 1 - 7 and so on.  If there were zero responses against a point on your scale then input '0' - don't leave the field blank."
              allowNA
              subQuestion
            />
            <SurveyElement
              labelText="# of response with score of 1"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='NewMemberScore1'
              allowNA
              doubleSubQuestion
              showIf={{
                NewMemberScale: { gte: 1 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 2"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='NewMemberScore2'
              allowNA
              doubleSubQuestion
              showIf={{
                NewMemberScale: { gte: 2 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 3"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='NewMemberScore3'
              allowNA
              doubleSubQuestion
              showIf={{
                NewMemberScale: { gte: 3 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 4"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='NewMemberScore4'
              allowNA
              doubleSubQuestion
              showIf={{
                NewMemberScale: { gte: 4 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 5"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='NewMemberScore5'
              allowNA
              doubleSubQuestion
              showIf={{
                NewMemberScale: { gte: 5 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 6"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='NewMemberScore6'
              allowNA
              doubleSubQuestion
              showIf={{
                NewMemberScale: { gte: 6 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 7"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='NewMemberScore7'
              allowNA
              doubleSubQuestion
              showIf={{
                NewMemberScale: { gte: 7 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 8"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='NewMemberScore8'
              allowNA
              doubleSubQuestion
              showIf={{
                NewMemberScale: { gte: 8 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 9"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='NewMemberScore9'
              allowNA
              doubleSubQuestion
              showIf={{
                NewMemberScale: { gte: 9 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 10"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='NewMemberScore10'
              allowNA
              doubleSubQuestion
              showIf={{
                NewMemberScale: { gte: 10 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='NewMemberScore1'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                NewMemberScale: { eq: 1 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='NewMemberScore1 + NewMemberScore2'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                NewMemberScale: { eq: 2 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='NewMemberScore1 + NewMemberScore2 + NewMemberScore3'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                NewMemberScale: { eq: 3 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='NewMemberScore1 + NewMemberScore2 + NewMemberScore3 + NewMemberScore4'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                NewMemberScale: { eq: 4 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='NewMemberScore1 + NewMemberScore2 + NewMemberScore3 + NewMemberScore4 + NewMemberScore5'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                NewMemberScale: { eq: 5 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='NewMemberScore1 + NewMemberScore2 + NewMemberScore3 + NewMemberScore4 + NewMemberScore5 + NewMemberScore6'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                NewMemberScale: { eq: 6 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='NewMemberScore1 + NewMemberScore2 + NewMemberScore3 + NewMemberScore4 + NewMemberScore5 + NewMemberScore6 + NewMemberScore7'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                NewMemberScale: { eq: 7 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='NewMemberScore1 + NewMemberScore2 + NewMemberScore3 + NewMemberScore4 + NewMemberScore5 + NewMemberScore6 + NewMemberScore7 + NewMemberScore8'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                NewMemberScale: { eq: 8 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='NewMemberScore1 + NewMemberScore2 + NewMemberScore3 + NewMemberScore4 + NewMemberScore5 + NewMemberScore6 + NewMemberScore7 + NewMemberScore8 + NewMemberScore9'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                NewMemberScale: { eq: 9 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='NewMemberScore1 + NewMemberScore2 + NewMemberScore3 + NewMemberScore4 + NewMemberScore5 + NewMemberScore6 + NewMemberScore7 + NewMemberScore8 + NewMemberScore9 + NewMemberScore10'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                NewMemberScale: { eq: 10 }
              }}
            />
            <SurveyElement
              questionNumber='99.c'
              labelText="Number of members surveyed"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='NewMemberSurveyed'
              note="Please provide either the number of surveys sent/popped-up/requested OR provide the response rate"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='99.d'
              labelText="% response rate"
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE_UK}
              placeholder='%, n/a'
              name='NewMemberResponseRate'
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='99.e'
              labelText="What were your scale labels? (Contextual Data)"
              inputType={ElementType.TEXT}
              name='NewMemberScaleLabels'
              note="e.g., 1-10 (with 1 being not at all satisfied and 10 being extremely satisfied)"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='99.f'
              labelText="How quickly do you typically send your survey after the activity?"
              note="e.g., Within one month after the quarter closes."
              name='NewMemberTimeliness'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='99.g'
              labelText="How frequently are you surveying?"
              note="e.g., every quarter or ongoing / constant"
              name='NewMemberFrequency'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='99.h'
              labelText="Method"
              note="e.g., SurveyMonkey - online survey"
              name='NewMemberSurveyMethod'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection labelText='General member perception'>
          <SurveyElement
            questionNumber='100'
            labelText="Did you send out general surveys to members?"
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='MemberPerceptionSurveyYN'
          />
          <SurveyConditionalSegment
            showIf={{
              MemberPerceptionSurveyYN: { not: CommonResponses.NO.toLowerCase() }
            }}
          >
            <SurveyElement
              labelText="Optimized question: How satisfied are you with the overall service you have received from the administrator?"
            />
            <SurveyElement
              questionNumber='100.a'
              labelText="Did you use the optimized question above verbatim?"
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              name='MemberPerceptionYN'
              subQuestion
            />
            <SurveyElement
              questionNumber='100.a.a1'
              labelText="If you didn't use the optimized question, what was the closest matching question in your survey?"
              inputType={ElementType.TEXTAREA}
              name='MemberPerceptionDirectionalQuestionUse'
              doubleSubQuestion
              showIf={{
                MemberPerceptionYN: { not: CommonResponses.YES.toLowerCase() }
              }}
            />
            <SurveyElement
              questionNumber='100.b'
              labelText="How many points are on your scale?"
              inputType={ElementType.SELECT}
              options={SelectCombos.ONE_TO_TEN}
              placeholder='#, n/a'
              name='MemberPerceptionScale'
              note="If you have a 1 - 7 scale, then add data in columns 1 - 7 and so on.  If there were zero responses against a point on your scale then input '0' - don't leave the field blank."
              allowNA
              subQuestion
            />
            <SurveyElement
              labelText="# of response with score of 1"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='MemberPerceptionScore1'
              allowNA
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { gte: 1 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 2"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='MemberPerceptionScore2'
              allowNA
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { gte: 2 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 3"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='MemberPerceptionScore3'
              allowNA
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { gte: 3 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 4"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='MemberPerceptionScore4'
              allowNA
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { gte: 4 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 5"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='MemberPerceptionScore5'
              allowNA
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { gte: 5 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 6"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='MemberPerceptionScore6'
              allowNA
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { gte: 6 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 7"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='MemberPerceptionScore7'
              allowNA
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { gte: 7 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 8"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='MemberPerceptionScore8'
              allowNA
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { gte: 8 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 9"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='MemberPerceptionScore9'
              allowNA
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { gte: 9 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 10"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='MemberPerceptionScore10'
              allowNA
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { gte: 10 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='MemberPerceptionScore1'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { eq: 1 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='MemberPerceptionScore1 + MemberPerceptionScore2'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { eq: 2 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='MemberPerceptionScore1 + MemberPerceptionScore2 + MemberPerceptionScore3'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { eq: 3 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='MemberPerceptionScore1 + MemberPerceptionScore2 + MemberPerceptionScore3 + MemberPerceptionScore4'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { eq: 4 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='MemberPerceptionScore1 + MemberPerceptionScore2 + MemberPerceptionScore3 + MemberPerceptionScore4 + MemberPerceptionScore5'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { eq: 5 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='MemberPerceptionScore1 + MemberPerceptionScore2 + MemberPerceptionScore3 + MemberPerceptionScore4 + MemberPerceptionScore5 + MemberPerceptionScore6'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { eq: 6 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='MemberPerceptionScore1 + MemberPerceptionScore2 + MemberPerceptionScore3 + MemberPerceptionScore4 + MemberPerceptionScore5 + MemberPerceptionScore6 + MemberPerceptionScore7'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { eq: 7 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='MemberPerceptionScore1 + MemberPerceptionScore2 + MemberPerceptionScore3 + MemberPerceptionScore4 + MemberPerceptionScore5 + MemberPerceptionScore6 + MemberPerceptionScore7 + MemberPerceptionScore8'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { eq: 8 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='MemberPerceptionScore1 + MemberPerceptionScore2 + MemberPerceptionScore3 + MemberPerceptionScore4 + MemberPerceptionScore5 + MemberPerceptionScore6 + MemberPerceptionScore7 + MemberPerceptionScore8 + MemberPerceptionScore9'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { eq: 9 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='MemberPerceptionScore1 + MemberPerceptionScore2 + MemberPerceptionScore3 + MemberPerceptionScore4 + MemberPerceptionScore5 + MemberPerceptionScore6 + MemberPerceptionScore7 + MemberPerceptionScore8 + MemberPerceptionScore9 + MemberPerceptionScore10'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                MemberPerceptionScale: { eq: 10 }
              }}
            />
            <SurveyElement
              questionNumber='100.c'
              labelText="Number of members surveyed"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='MemberPerceptionSurveyed'
              note="Please provide either the number of surveys sent/popped-up/requested OR provide the response rate"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='100.d'
              labelText="% response rate"
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE_UK}
              placeholder='%, n/a'
              name='MemberPerceptionResponseRate'
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='100.e'
              labelText="What were your scale labels? (Contextual Data)"
              inputType={ElementType.TEXT}
              name='MemberPerceptionScaleLabels'
              note="e.g., 1-10 (with 1 being not at all satisfied and 10 being extremely satisfied)"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='100.f'
              labelText="How quickly do you typically send your survey after the activity?"
              note="e.g., Within one month after the quarter closes."
              name='MemberPerceptionTimeliness'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='100.g'
              labelText="How frequently are you surveying?"
              note="e.g., every quarter or ongoing / constant"
              name='MemberPerceptionFrequency'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='100.h'
              labelText="Method"
              note="e.g., SurveyMonkey - online survey"
              name='MemberPerceptionSurveyMethod'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection labelText='General employer perception'>
          <SurveyElement
            questionNumber='101'
            labelText="Did you send out general surveys to employers?"
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='EmployerPerceptionSurveyYN'
          />
          <SurveyConditionalSegment
            showIf={{
              EmployerPerceptionSurveyYN: { not: CommonResponses.NO.toLowerCase() }
            }}
          >
            <SurveyElement
              labelText="Optimized question: How satisfied are you with the overall service you have received from the administrator?"
            />
            <SurveyElement
              questionNumber='101.a'
              labelText="Did you use the optimized question above verbatim?"
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              name='EmployerPerceptionYN'
              subQuestion
            />
            <SurveyElement
              questionNumber='101.a.a1'
              labelText="If you didn't use the optimized question, what was the closest matching question in your survey?"
              inputType={ElementType.TEXTAREA}
              name='EmployerPerceptionDirectionalQuestionUse'
              doubleSubQuestion
              showIf={{
                EmployerPerceptionYN: { not: CommonResponses.YES.toLowerCase() }
              }}
            />
            <SurveyElement
              questionNumber='101.b'
              labelText="How many points are on your scale?"
              inputType={ElementType.SELECT}
              options={SelectCombos.ONE_TO_TEN}
              placeholder='#, n/a'
              name='EmployerPerceptionScale'
              note="If you have a 1 - 7 scale, then add data in columns 1 - 7 and so on.  If there were zero responses against a point on your scale then input '0' - don't leave the field blank."
              allowNA
              subQuestion
            />
            <SurveyElement
              labelText="# of response with score of 1"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='EmployerPerceptionScore1'
              allowNA
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { gte: 1 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 2"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='EmployerPerceptionScore2'
              allowNA
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { gte: 2 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 3"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='EmployerPerceptionScore3'
              allowNA
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { gte: 3 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 4"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='EmployerPerceptionScore4'
              allowNA
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { gte: 4 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 5"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='EmployerPerceptionScore5'
              allowNA
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { gte: 5 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 6"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='EmployerPerceptionScore6'
              allowNA
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { gte: 6 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 7"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='EmployerPerceptionScore7'
              allowNA
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { gte: 7 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 8"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='EmployerPerceptionScore8'
              allowNA
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { gte: 8 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 9"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='EmployerPerceptionScore9'
              allowNA
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { gte: 9 }
              }}
            />
            <SurveyElement
              labelText="# of response with score of 10"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='#, n/a'
              name='EmployerPerceptionScore10'
              allowNA
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { gte: 10 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='EmployerPerceptionScore1'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { eq: 1 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='EmployerPerceptionScore1 + EmployerPerceptionScore2'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { eq: 2 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='EmployerPerceptionScore1 + EmployerPerceptionScore2 + EmployerPerceptionScore3'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { eq: 3 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='EmployerPerceptionScore1 + EmployerPerceptionScore2 + EmployerPerceptionScore3 + EmployerPerceptionScore4'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { eq: 4 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='EmployerPerceptionScore1 + EmployerPerceptionScore2 + EmployerPerceptionScore3 + EmployerPerceptionScore4 + EmployerPerceptionScore5'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { eq: 5 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='EmployerPerceptionScore1 + EmployerPerceptionScore2 + EmployerPerceptionScore3 + EmployerPerceptionScore4 + EmployerPerceptionScore5 + EmployerPerceptionScore6'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { eq: 6 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='EmployerPerceptionScore1 + EmployerPerceptionScore2 + EmployerPerceptionScore3 + EmployerPerceptionScore4 + EmployerPerceptionScore5 + EmployerPerceptionScore6 + EmployerPerceptionScore7'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { eq: 7 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='EmployerPerceptionScore1 + EmployerPerceptionScore2 + EmployerPerceptionScore3 + EmployerPerceptionScore4 + EmployerPerceptionScore5 + EmployerPerceptionScore6 + EmployerPerceptionScore7 + EmployerPerceptionScore8'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { eq: 8 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='EmployerPerceptionScore1 + EmployerPerceptionScore2 + EmployerPerceptionScore3 + EmployerPerceptionScore4 + EmployerPerceptionScore5 + EmployerPerceptionScore6 + EmployerPerceptionScore7 + EmployerPerceptionScore8 + EmployerPerceptionScore9'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { eq: 9 }
              }}
            />
            <SurveyElement
              inputType={ElementType.CALCULATED}
              labelText="Total # of responses"
              formula='EmployerPerceptionScore1 + EmployerPerceptionScore2 + EmployerPerceptionScore3 + EmployerPerceptionScore4 + EmployerPerceptionScore5 + EmployerPerceptionScore6 + EmployerPerceptionScore7 + EmployerPerceptionScore8 + EmployerPerceptionScore9 + EmployerPerceptionScore10'
              format={NumberFormat.INTEGER}
              doubleSubQuestion
              showIf={{
                EmployerPerceptionScale: { eq: 10 }
              }}
            />
            <SurveyElement
              questionNumber='101.c'
              labelText="Number of employers surveyed"
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              placeholder='#, n/a'
              name='EmployerPerceptionSurveyed'
              note="Please provide either the number of surveys sent/popped-up/requested OR provide the response rate"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='101.d'
              labelText="% response rate"
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE_UK}
              placeholder='%, n/a'
              name='EmployerPerceptionResponseRate'
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='101.e'
              labelText="What were your scale labels? (Contextual Data)"
              inputType={ElementType.TEXT}
              name='EmployerPerceptionScaleLabels'
              note="e.g., 1-10 (with 1 being not at all satisfied and 10 being extremely satisfied)"
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='101.f'
              labelText="How quickly do you typically send your survey after the activity?"
              note="e.g., Within one month after the quarter closes."
              name='EmployerPerceptionTimeliness'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='101.g'
              labelText="How frequently are you surveying?"
              note="e.g., every quarter or ongoing / constant"
              name='EmployerPerceptionFrequency'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
            <SurveyElement
              questionNumber='101.h'
              labelText="Method"
              note="e.g., SurveyMonkey - online survey"
              name='EmployerPerceptionSurveyMethod'
              inputType={ElementType.TEXT}
              allowNA
              subQuestion
            />
          </SurveyConditionalSegment>
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  )
}